// Styles for AlertBanner go here.
import styled from 'styled-components';

export const StyledAlertBanner = styled.div``;
